import { customTime } from "@Engage.Core";
/**
 * DayTimeQualifier
 * DayTime is evaluated server-side using the rule's EvaluatedObject (start) and Value (end).
 * The SDK sends the current UTC time as HH:MM so the API can use it if needed.
 * Mirrors ConneXt v2 DayTime.getLocalTime() which uses UTC hours/minutes.
 */
export class DayTimeQualifier {
    constructor() {
        this.key = "DayTime";
    }
    process() {
        const now = customTime.get();
        const hours = String(now.getUTCHours()).padStart(2, "0");
        const minutes = String(now.getUTCMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    }
}
